module.exports = __webpack_public_path__ + "img/car.108e6156.png";